module.exports = __webpack_public_path__ + "static/cely_rose_main-d323a56cdcf2ec4c7f0ec428f3ededab.png";